import {NotesApi, Configuration} from '@soluto-private/anywhere-expert-notes-api-client';
import {authorizedFetch} from '@anywhere-expert/auth';
import {configuration} from '@anywhere-expert/core';

const notesApi = new NotesApi(new Configuration({basePath: configuration.notesApiUrl, fetchApi: authorizedFetch}));

export default notesApi;
